var React = require('react');

function IcAwsIotResourceAction (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"st0","d":"M20,0C8.972,0,0,8.972,0,20s8.972,20,20,20s20-8.972,20-20S31.028,0,20,0z M20,38.298\n\tC9.91,38.298,1.702,30.09,1.702,20S9.91,1.702,20,1.702S38.298,9.911,38.298,20S30.09,38.298,20,38.298z M15.829,6.652l-1.242,1.164\n\tL26.016,20L14.588,32.183l1.242,1.165l11.975-12.766c0.307-0.327,0.307-0.837,0-1.164L15.829,6.652z"}));
}

IcAwsIotResourceAction.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 40 40","style":{"enableBackground":"new 0 0 40 40"},"xmlSpace":"preserve"};

module.exports = IcAwsIotResourceAction;

IcAwsIotResourceAction.default = IcAwsIotResourceAction;
